






















import Vue from 'vue'
import Component from 'vue-class-component'
import {State, Mutation, Action} from 'vuex-class'
import {Prop} from 'vue-property-decorator'
import {MutationTypes} from '@/modules/blog/store/mutations'
import {Post} from '@/modules/blog/types'
import {notify, Colors} from '@/modules/core/notification'

/**
 * Confirmación de guardado de la publicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PostSaveConfirm extends Vue {

    /**
     * Publicación en edición
     */
    @State(state => state.blog.editingPost)
    public post: Post

    @State(state => state.blog.saveConfirm)
    public visible: boolean

    @Prop({type: Boolean, default: false})
    public isNew: boolean

    @Mutation(`blog/${MutationTypes.ShowSaveConfirm}`)
    public showSaveConfirm: (show: boolean) => void

    @Action('blog/savePost')
    public savePost: (payload: { isNew: boolean }) => void
    public saving = false


    public async save () {
        this.saving = true
        try {
            await this.savePost({isNew: this.isNew})
        } catch (error) {
            this.saving = false
            notify('Se ha producido un error al guardar la publicación', Colors.Error)

            return
        }

        this.saving = false
        this.showSaveConfirm(false)

        // Reemplaza la ruta actual de la publicación por la publicación actual
        if (this.$route.params.id === 'nueva') {
           await this.$router.replace({
               name: 'blog.post',
               params: { id: this.post.id.toString()},
           })
       }

        // Notificación de guardado correcto
        notify(`La publicación ${this.post.id} se ha actualizado correctamente`, Colors.Success, {
            subject: 'Blog',
            goToAction: {
                buttonName: 'Ver publicación',
                route: {
                    name: 'blog.post',
                    params: {id: this.post.id.toString()},
                },
            },
        })
    }
}
